import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { getImgixSrc } from '@utils/images';

import Disclosure from './Disclousre';

const SecondSection = () => {
  return (
    <div className="flex w-full flex-col items-center sm:w-auto">
      <div>
        <LazyImgixImage
          alt="laptop"
          src={getImgixSrc({
            path: 'landing_pages/free_pro_trial/laptop.png',
            isEnvDependent: false,
          })}
          wrapperClassName="w-full"
          sizes="(min-width: 1200px) 424px, (min-width: 768px) 346px, 320px"
        />
      </div>
      <div>
        <LazyImgixImage
          alt="org charts"
          src={getImgixSrc({
            path: 'landing_pages/free_pro_trial/org_charts.png',
            isEnvDependent: false,
          })}
          wrapperClassName="w-full my-16"
          sizes="(min-width: 1200px) 338px, (min-width: 768px) 285px, 320px"
        />
      </div>
      <div>
        <LazyImgixImage
          alt="data tools"
          src={getImgixSrc({
            path: 'landing_pages/free_pro_trial/data_tools.png',
            isEnvDependent: false,
          })}
          wrapperClassName="w-full my-16"
          sizes="(min-width: 1200px) 338px, (min-width: 768px) 338px, 320px"
        />
      </div>
      <Disclosure className="block sm:hidden" />
    </div>
  );
};

export default SecondSection;
